import { Mark, mergeAttributes } from '@tiptap/core';

export interface SurveyColorOptions {
  HTMLAttributes: Record<string, any>;
}

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    surveyColor: {
      /**
       * Set an surveyColor mark
       */
      setSurveyColor: () => ReturnType;
      /**
       * Toggle an surveyColor mark
       */
      toggleSurveyColor: () => ReturnType;
      /**
       * Unset an surveyColor mark
       */
      unsetSurveyColor: () => ReturnType;
    };
  }
}

/**
 * Custom Mark to add a surveyColor class to the text
 */
export const SurveyColorStyle = Mark.create<SurveyColorOptions>({
  name: 'surveyColor',

  addOptions() {
    return {
      HTMLAttributes: { class: 'survey-color' },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'span',
        getAttrs: (element: string | HTMLElement) => {
          return (
            typeof element !== 'string' &&
            element.getAttribute('class') ===
              this.options.HTMLAttributes.class &&
            null
          );
        },
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'span',
      mergeAttributes(this.options.HTMLAttributes, HTMLAttributes),
      0,
    ];
  },

  addCommands() {
    return {
      setSurveyColor:
        () =>
        ({ commands }) => {
          return commands.setMark(this.name);
        },
      toggleSurveyColor:
        () =>
        ({ commands }) => {
          return commands.toggleMark(this.name);
        },
      unsetSurveyColor:
        () =>
        ({ commands }) => {
          return commands.unsetMark(this.name);
        },
    };
  },
});
